export enum PrintOfficeAvailabilityTypes {
    Office,
    Variation,
    Size,
    Type,
    Extra
}